/**
 * @fileoverview หน้า "Model" (รุ่น)
 *
 * ชื่อบนหน้าจอ = รุ่น / Model
 * ข้อมูลจริง   = table `models` (API: warehouse/models, permission: models.*)
 * ความสัมพันธ์ = belongsTo `brands` (แบรนด์ / Brand) -> ช่อง "แบรนด์" คือ brand_id — ไม่บังคับ (บางรุ่นไม่มีแบรนด์) ; Brand 1 — N Model
 * อ้างอิงจาก   = part_masters.model_id
 *
 * กฎการบันทึก:
 *   - รหัสรุ่น / ชื่อรุ่น ห้ามว่าง (รหัสรุ่นใช้ค่าเดียวกับชื่อรุ่นได้ — ปุ่ม "ใช้ชื่อเดียวกับรหัส")
 *   - รหัสรุ่นห้ามซ้ำ "ภายใต้แบรนด์เดียวกัน" (รหัสเดียวกันคนละแบรนด์ได้) -> ซ้ำแจ้ง "รหัสรุ่นนี้มีอยู่แล้วในแบรนด์นี้" (backend เทียบแบบไม่สนตัวพิมพ์)
 * Import Excel (Template 03_Model_Template) ทำที่ศูนย์นำเข้าข้อมูล (/wh/import-center) — หน้านี้ไม่มีปุ่มนำเข้า
 *
 * ชื่อ field/API/permission ยังใช้คำว่า model ตามเดิมโดยตั้งใจ (ดู glossary ใน components/global.js)
 */

import React, { Component } from "react";
import {
  company,
  loading,
  float,
  NavbarWarehouse,
  Pagination,
  Modal,
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  t,
  Select,
  ActionIconButton,
  ACTION_ICONS,
  fmtInt,
} from "../../components/CustomComponent.js";
import { can } from "../../utils/permission";

// แปลงข้อความ error จาก backend ("This Model Code already exists") เป็นข้อความที่ผู้ใช้เข้าใจ
const modelErrorMessage = (message) => {
  const msg = String(message || "");
  if (/already exists/i.test(msg) && /code/i.test(msg)) return t("material_group_code_exists");
  return msg || t("error_occurred");
};

export default class ModelManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_search: "",
      filter_brand: "",
      filter_status: "",

      modal_create: false,
      modal_update: false,
      count: 0,

      // Form States (Modal)
      uid: "",
      company_id: company?.id || "", // Default company_id
      brand_id: "", // แบรนด์ (Brand) ที่เลือก (FK -> brands) — ไม่บังคับ ("" = ไม่ระบุแบรนด์)
      model_code: "",
      name: "",
      description: "",
      is_active: "Active",

      // List Data
      data: [],
      data_all: [], // ทุกรายการตาม filter ปัจจุบัน (ไม่แบ่งหน้า) — ใช้นับ KPI การ์ด
      brands: [], // ข้อมูลแบรนด์ (Brand) สำหรับ Dropdown (warehouse/brands)
    };
  }

  async componentDidMount() {
    loading(true);
    await this.GetBrands(); // โหลดข้อมูล Brand ไว้ใช้ใน Dropdown
    await this.Get(1);
    loading(false);
  }

  GetBrands = async () => {
    // page: 0 = ไม่แบ่งหน้า -> ได้แบรนด์ทั้งหมดของบริษัทสำหรับ Dropdown
    let result = await GET("warehouse/brands", {
        page_size: 100000,
        page: 0,
        data_search: ""
    });
    if (result?.status) {
      this.setState({ brands: result.data || [] });
    }
  };

  Get = async (page) => {
    const { filter_search, filter_brand, filter_status } = this.state;
    let data, count;
    loading(true);

    const params = {
      data_search: filter_search || "",
      brand_id: filter_brand || "",
      is_active: filter_status || "",
    };

    // ตาราง = หน้าปัจจุบัน (10 แถว), KPI การ์ด = ทุกรายการตาม filter (page: 0 = ไม่แบ่งหน้า) — แบบเดียวกับหน้าแบรนด์
    let [result, result_all] = await Promise.all([
      GET("warehouse/models", { ...params, page_size: 10, page: page }),
      GET("warehouse/models", { ...params, page_size: 100000, page: 0 }),
    ]);

    if (result?.status) {
      data = result.data;
      count = result.pagination?.count || 0;
    }

    this.setState({ data: data || [], count, data_all: result_all?.status ? result_all.data || [] : [] });
    loading(false);
  };

  CreateUpdate = async () => {
    const {
      uid,
      company_id,
      brand_id,
      model_code,
      name,
      description,
      is_active,
    } = this.state;

    // Validation
    if (!model_code.trim()) {
      alert("", "warning", t("warning"), t("verify_material_group_code"));
      return;
    } else if (!name.trim()) {
      alert("", "warning", t("warning"), t("verify_material_group_name"));
      return;
    }

    if (
      await alert(
        "",
        "info",
        t("confirm"),
        t("confirm_submission"),
        t("confirm"),
        t("cancel"),
      )
    ) {
      loading(true);
      
      // Request Body
      let body = {
        company_id,
        brand_id: brand_id || null, // แบรนด์ไม่บังคับ — null = ไม่ระบุ / ล้างแบรนด์เดิม
        model_code: model_code.trim(),
        name: name.trim(),
        description,
        is_active: is_active === "Active",
      };

      // Call API
      let result = !uid
        ? await POST("warehouse/models", body)
        : await PUT("warehouse/models/" + uid, body);

      if (result?.status === true) {
        alert("#", "success");
        this.setState({ modal_create: false, modal_update: false }, () => {
            this.Get(1); // Refresh data
        });
      } else {
        alert(
          "",
          "warning",
          t("warning"),
          modelErrorMessage(result?.message),
        );
      }
      loading(false);
    }
  };

  Delete = async (id) => {
    if (
      await alert(
        "",
        "warning",
        t("delete_item"),
        t("delete_desc"),
        t("confirm"),
        t("cancel"),
      )
    ) {
      loading(true);
      let result = await DELETE("warehouse/models/" + id, null);
      if (result?.status) {
        alert("#", "success");
        this.Get(1); // Refresh data after delete
      }
      loading(false);
    }
  };

  resetForm = () => {
    this.setState({
      uid: "",
      brand_id: "",
      model_code: "",
      name: "",
      description: "",
      is_active: "Active",
    });
  };

  render() {
    const {
      data,
      count,
      data_all,
      brands,
      filter_search,
      filter_brand,
      filter_status,
      modal_create,
      modal_update,
      brand_id,
      model_code,
      name,
      description,
      is_active,
    } = this.state;

    return (
        <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
            <NavbarWarehouse />
            <div className="body p-4 mt-3">
                {/* Header Section */}
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
                    <div>
                        <h3 className="fw-bold mb-1 text-dark">{t("material_group_management")}</h3>
                        <div className="text-secondary text-14">{t("manage_material_groups_desc")}</div>
                    </div>
                </div>

                {/* Top KPI Cards */}
                <div className="row g-3 mb-4">
                    <div className="col-lg-4 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                            <div className="d-flex align-items-center justify-content-between">
                                <div>
                                    <div className="text-secondary text-12 mb-1">{t("total_material_groups")}</div>
                                    <h4 className="fw-bold text-dark mb-0">{fmtInt(data_all.length)}</h4>
                                </div>
                                <div className="wpx-40 hpx-40 rounded bg-primary-light text-primary d-flex align-items-center justify-content-center text-18 icon">
                                    {"\uf1b2"} {/* Cube icon for model */}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                            <div className="d-flex align-items-center justify-content-between">
                                <div>
                                    <div className="text-secondary text-12 mb-1">{t("active_material_groups")}</div>
                                    <h4 className="fw-bold text-success mb-0">{fmtInt(data_all.filter((d) => d.is_active).length)}</h4>
                                </div>
                                <div className="wpx-40 hpx-40 rounded bg-success-light text-success d-flex align-items-center justify-content-center text-18 icon">{"\uf4fc"}</div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                            <div className="d-flex align-items-center justify-content-between">
                                <div>
                                    <div className="text-secondary text-12 mb-1">{t("inactive_material_groups")}</div>
                                    <h4 className="fw-bold text-secondary mb-0">{fmtInt(data_all.filter((d) => !d.is_active).length)}</h4>
                                </div>
                                <div className="wpx-40 hpx-40 rounded bg-light text-secondary border d-flex align-items-center justify-content-center text-18 icon">{"\uf4fa"}</div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main White Container */}
                <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
                    {/* Top Filter Toolbar */}
                    <div className="d-flex flex-wrap justify-content-between align-items-center">
                        <div className="d-flex gap-2 flex-wrap">
                            <div className="position-relative" style={{ maxWidth: "300px", width: "100%" }}>
                                <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{"\uf002"}</span>
                                <input
                                    type="text"
                                    className="form-control ps-5 wpx-300"
                                    style={{ height: "38px" }}
                                    placeholder={t("search_material_groups")}
                                    value={filter_search}
                                    onChange={(e) => this.setState({ filter_search: e.target.value })}
                                />
                            </div>
                            <Select
                                className="form-control wpx-150"
                                options={brands.map((b) => ({ value: b.uid, label: b.name }))}
                                value={filter_brand}
                                onChange={(e) => this.setState({ filter_brand: e })}
                                placeholder={t("all_material_types")}
                                defaultLabel={t("all_material_types")}
                            />
                            <Select
                                className="form-control wpx-150"
                                options={[
                                    { value: "true", label: t("active") },
                                    { value: "false", label: t("inactive") },
                                ]}
                                value={filter_status}
                                onChange={(e) => this.setState({ filter_status: e })}
                                placeholder={t("all_status")}
                                defaultLabel={t("all_status")}
                            />
                            <div className="d-flex gap-2">
                                <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.Get(1)}>
                                    {t("filter")}
                                </button>
                                <button
                                    className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm"
                                    onClick={() => this.setState({ filter_search: "", filter_brand: "", filter_status: "" }, () => this.Get(1))}
                                >
                                    {t("clear_all")}
                                </button>
                            </div>
                        </div>
                        {can("models.create") && (
                        <button
                            className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center"
                            onClick={() => {
                                this.resetForm();
                                this.setState({ modal_create: true });
                            }}
                        >
                            <span className="me-2 text-16">+</span> {t("add_material_group")}
                        </button>)}
                    </div>
                </div>

                <div className="bg-white rounded-4 shadow-sm mb-4 overflow-hidden">
                    {/* Models Table */}
                    <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0" style={{ minWidth: "1000px" }}>
                            <thead>
                                <tr className="text-dark fw-bold text-12 border-bottom border-light">
                                    <th className="py-3 border-0 wpx-250">{t("material_group")}</th>
                                    <th className="py-3 border-0 wpx-200">{t("material_type")}</th>
                                    <th className="py-3 border-0 wpx-250">{t("description")}</th>
                                    <th className="py-3 border-0 text-center wpx-100">{t("status")}</th>
                                    <th className="py-3 border-0 text-center wpx-100">{t("actions")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item, idx) => (
                                    <tr key={idx} className="border-bottom border-light bg-white">
                                        {/* Model Info */}
                                        <td className="py-3">
                                            <div className="d-flex align-items-center">
                                                <div
                                                    className={`wpx-35 hpx-35 rounded-circle text-white d-flex align-items-center justify-content-center me-3 flex-shrink-0 fw-bold text-12 bg-primary`}
                                                >
                                                    <span className="icon">{"\uf1b2"}</span>
                                                </div>
                                                <div>
                                                    <div className="fw-bold text-dark text-14">{item.name}</div>
                                                    <div className="text-secondary text-10">
                                                        {t("code")}: {item.model_code}
                                                    </div>
                                                </div>
                                            </div>
                                        </td>

                                        {/* Brand Info */}
                                        <td>
                                            <span className={`badge bg-primary-light text-primary rounded-pill px-2 py-1 fw-bold text-10 border border-primary`}>{item.brand?.name || "-"}</span>
                                        </td>

                                        {/* Description */}
                                        <td>
                                            <div className="text-secondary text-14 text-truncate" style={{ maxWidth: "200px" }}>
                                                {item.description || "-"}
                                            </div>
                                        </td>

                                        {/* Status */}
                                        <td className="text-center">
                                            {item.is_active ? (
                                                <span className="text-success text-12 fw-bold bg-success-light px-2 py-1 rounded-pill">{t("active")}</span>
                                            ) : (
                                                <span className="text-secondary text-12 fw-bold bg-light px-2 py-1 rounded-pill border">{t("inactive")}</span>
                                            )}
                                        </td>

                                        {/* Actions */}
                                        <td className="text-center">
                                            <div className="d-flex align-items-center gap-2 justify-content-center">
                                                                                                <ActionIconButton
                                                    label={can("models.update") ? t("edit") : t("view")}
                                                    icon={can("models.update") ? ACTION_ICONS.edit : ACTION_ICONS.view}
                                                    variant={can("models.update") ? "warning" : "primary"}
                                                    onClick={() => {
                                                        this.setState({
                                                            modal_update: true,
                                                            ...item,
                                                            brand_id: item.brand?.uid || "",
                                                            is_active: item.is_active ? "Active" : "Inactive",
                                                        });
                                                    }}
                                                />
                                                {can("models.delete") && (
                                                <ActionIconButton
                                                    label={t("delete")}
                                                    icon={ACTION_ICONS.delete}
                                                    variant="danger"
                                                    onClick={() => {
                                                        this.Delete(item.uid);
                                                    }}
                                                />)}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Footer Pagination */}
                <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap text-secondary text-12">
                    <div>
                        {t("showing")} {data.length > 0 ? 1 : 0}-{data.length} {t("of")} {fmtInt(count)} {t("material_groups_count")}
                    </div>
                    <Pagination className="mb-0" count={Math.ceil(count / 10) || 1} showFirstButton={false} showLastButton={false} onChange={(_, page) => this.Get(page)} />
                </div>
            </div>

            {/* MODAL: ADD/EDIT MODEL */}
            <Modal
                size="md"
                show={modal_create || modal_update}
                onHide={() => this.setState({ modal_create: false, modal_update: false })}
                centered
                contentClassName="border-0 rounded-4 overflow-hidden shadow-lg"
            >
                <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
                    <h5 className="fw-bold mb-0 text-dark">{modal_update ? t("edit_material_group") : t("add_new_material_group")}</h5>
                </Modal.Header>
                <Modal.Body className="p-4 bg-white">
<fieldset disabled={(this.state.modal_update && !can("models.update"))} className="border-0 p-0 m-0" style={(this.state.modal_update && !can("models.update")) ? { pointerEvents: "none" } : undefined}>
                    <div className="row g-4">
                        {/* Basic Information */}
                        <div className="col-12">
                            <h6 className="fw-bold mb-1 d-flex align-items-center">
                                <span className="icon text-primary me-2">{"\uf05a"}</span> {t("basic_information")}
                            </h6>
                            <small className="text-muted d-block mb-3">{t("material_group_basic_info_desc")}</small>
                            <div className="row g-3">
                                <div className="col-12">
                                    <label className="form-label text-14 text-dark mb-2">
                                        {t("material_group_code")} <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control py-2"
                                        placeholder="e.g. BV-65"
                                        value={model_code}
                                        onChange={(e) => this.setState({ model_code: e.target.value })}
                                        disabled={modal_update}
                                    />
                                </div>
                                <div className="col-12">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <label className="form-label text-14 text-dark mb-0">
                                            {t("material_group_name")} <span className="text-danger">*</span>
                                        </label>
                                        {/* รหัสรุ่นใช้ค่าเดียวกับชื่อรุ่นได้ -> คัดลอกรหัสมาเป็นชื่อในคลิกเดียว */}
                                        <button
                                            type="button"
                                            className="btn btn-link btn-sm p-0 text-12 text-decoration-none"
                                            disabled={!model_code.trim()}
                                            onClick={() => this.setState({ name: model_code.trim() })}
                                        >
                                            {t("model_use_code_as_name")}
                                        </button>
                                    </div>
                                    <input type="text" className="form-control py-2" placeholder="e.g. BV-65" value={name} onChange={(e) => this.setState({ name: e.target.value })} />
                                </div>

                                <div className="col-12">
                                    <label className="form-label text-14 text-dark mb-2">
                                        {t("material_type")} <span className="text-secondary text-12">({t("optional")})</span>
                                    </label>
                                    {/* ไม่บังคับ — เลือก "ไม่ระบุแบรนด์" (ค่าว่าง) ได้ เพราะบางรุ่นไม่มีแบรนด์ */}
                                    <Select
                                        className="form-control py-1"
                                        options={brands.map((b) => ({ value: b.uid, label: b.brand_code && b.brand_code !== b.name ? `${b.brand_code} - ${b.name}` : b.name }))}
                                        value={brand_id}
                                        onChange={(e) => this.setState({ brand_id: e })}
                                        placeholder={t("model_no_brand")}
                                        defaultLabel={t("model_no_brand")}
                                    />
                                </div>

                                <div className="col-12">
                                    <label className="form-label text-14 text-dark mb-2">{t("description")}</label>
                                    <textarea
                                        className="form-control py-2"
                                        rows="3"
                                        placeholder={t("material_group_description")}
                                        value={description}
                                        onChange={(e) => this.setState({ description: e.target.value })}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Status */}
                        <div className="col-12 mt-2 border-top pt-4">
                            <h6 className="fw-bold mb-1 d-flex align-items-center">
                                <span className="icon text-primary me-2">{"\uf772"}</span> {t("status")}
                            </h6>
                            <div className="d-flex gap-4 mt-3">
                                <div className="form-check d-flex align-items-center gap-2">
                                    <input
                                        className="form-check-input mt-0 pointer"
                                        type="radio"
                                        name="modelStatus"
                                        id="statusActive"
                                        checked={is_active === "Active"}
                                        onChange={() => this.setState({ is_active: "Active" })}
                                    />
                                    <label className="form-check-label text-dark text-14 pointer" htmlFor="statusActive">
                                        {t("active")}
                                    </label>
                                </div>
                                <div className="form-check d-flex align-items-center gap-2">
                                    <input
                                        className="form-check-input mt-0 pointer"
                                        type="radio"
                                        name="modelStatus"
                                        id="statusInactive"
                                        checked={is_active === "Inactive"}
                                        onChange={() => this.setState({ is_active: "Inactive" })}
                                    />
                                    <label className="form-check-label text-dark text-14 pointer" htmlFor="statusInactive">
                                        {t("inactive")}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
</Modal.Body>
                <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
                    <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={() => this.setState({ modal_create: false, modal_update: false })}>
                        {t("cancel")}
                    </button>
{!(this.state.modal_update && !can("models.update")) && (
                    <button
                        className="btn btn-primary px-4 py-2 d-flex align-items-center rounded-3 fw-bold text-white shadow-sm"
                        style={{ backgroundColor: "#2563eb", borderColor: "#2563eb" }}
                        onClick={() => {
                            this.CreateUpdate();
                        }}
                    >
                        <span className="icon me-2">{"\uf0c7"}</span> {t("save")}
                    </button>)}
                </Modal.Footer>
            </Modal>
        </div>
    );
  }
}